import { Divider, Stack, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import theme from '../../theme';
import { useUserStore } from '../../stores/userStore';
import { trackExternalLinkClick } from '../../lib/gaEvents';
import { EXTERNAL_LINK_TYPE, CONTENT_TYPE } from '../../constants/gaEnums';
import { getPageTypeFromPath } from '../../lib/gaParams';

const NewsSourceWithDate = ({
  linkUrl,
  source,
  date,
  fontSize = 14,
  withDate = true,
  sx = {},
  contentId,
}) => {
  const user = useUserStore((state) => state.user);
  const { pathname } = useLocation();
  const pageType = getPageTypeFromPath(pathname);

  const handleSourceClick = () => {
    if (linkUrl) {
      trackExternalLinkClick(
        {
          linkType: EXTERNAL_LINK_TYPE.NEWS_SOURCE,
          contentType: CONTENT_TYPE.NEWS,
          contentId,
          pageType,
        },
        user,
      );
      window.open(linkUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={sx}>
      <Typography
        fontSize={fontSize}
        sx={{ color: theme.palette.secondary.main, cursor: 'pointer', whiteSpace: 'nowrap' }}
        onClick={handleSourceClick}
      >
        {source}
      </Typography>
      {withDate && date && (
        <>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ height: '8px', alignSelf: 'center', backgroundColor: theme.palette.grey.line }}
          />
          <Typography
            fontSize={fontSize}
            sx={{ color: theme.palette.black[4], whiteSpace: 'nowrap' }}
          >
            {date}
          </Typography>
        </>
      )}
    </Stack>
  );
};

export default NewsSourceWithDate;
